module.exports = __webpack_public_path__ + "static/img/1024_big.70b792f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1024_big.png
// module id = ihDt
// module chunks = 1